// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__2jjPs","dark":"Logo_dark___40rj","light":"Logo_light__2A81X"};